/**
 * @copyright Copyright 2022-2025 Epic Systems Corporation
 * @file Loading indicator when full page is loading
 * @module Epic.AppOrchard.Core.MainPageSpinner
 */

import { Spinner, SpinnerProps, VisuallyHidden } from "@chakra-ui/react";
import React, { FC, memo } from "react";

/** Loading indicator when full page is loading */
export const MainPageSpinner: FC<SpinnerProps> = memo((props) => {
	return (
		<Spinner role="status" ml="45%" mt="5%" w="5rem" h="5rem" borderWidth="5px" {...props}>
			<VisuallyHidden>Loading...</VisuallyHidden>
		</Spinner>
	);
});
